import { styled } from '../styled';

import { Box } from './box';

export const StyledFullInlineMessage = styled(Box)`
  * {
    display: inline !important;
  }
`;
